import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import AccountInformationComponent from './account-information.component';
import AccountInformationService from '../../services/account-information.service';

let AccountInformationModule = angular
  .module('AccountInformation', [
    uiRouter
  ])
  .component('accountInformation', AccountInformationComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('accountInformation', {
      url: '/account-information',
      params: {
        activeTab: null
      },
      data: {
        authRequired: true,
        paymentExempt: true
      },
      views: {
        'menu': "menu",
        'content': {
          component: 'accountInformation',
          bindings: {
            accountInfo: 'accountInfo',
            userObservable: 'userObservable',
            pointOfSalesCount: 'pointOfSalesCount',
            spinPadCount: 'spinPadCount',
            pointOfSalesUnitPrice: 'pointOfSalesUnitPrice',
            spinPadUnitPrice: 'spinPadUnitPrice'
          }
        }
      },
      resolve: {
        accountInfo: (AccountInformationService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('edit-account')? AccountInformationService.getAccountInfo() : {};
        },
        countries: (CountriesService) => CountriesService.getCountries(),
        timezones: (TimezonesService) => TimezonesService.getTimezones(),
        userObservable: (AccountInformationService) => AccountInformationService.getUser(),
        activeTab: ($transition$) => $transition$.params().activeTab,
        pointOfSalesCount: (ContentService) => {
          return ContentService.countAccountPointOfSales()
            .toPromise()
        },
        spinPadCount: (ContentService) => {
          return ContentService.countAccountHandies()
            .toPromise()
        },
        pointOfSalesUnitPrice: () => 30.00,
        spinPadUnitPrice: () => 5.00,
      }
    });
  })
  .name;

export default AccountInformationModule;



// WEBPACK FOOTER //
// ./src/app/pages/account-information/account-information.module.js